import { ImportSidePanelAction, ImportSidePanelActions} from "../actions";
import { ImportSidePanelState } from "../state";

export const importSidePanelInitialState: ImportSidePanelState = {
  isLoading: false,
  isOpen: false,
};

export const importSidePanelReducer = (state: ImportSidePanelState, action: ImportSidePanelActions): ImportSidePanelState => {
  switch (action.type) {
    case ImportSidePanelAction.HideSidePanel:
      return Object.freeze(importSidePanelInitialState);
    case ImportSidePanelAction.GetStepDetail:
      return Object.freeze({
        ...state,
        isLoading: true,
        isOpen: true,
        step: action.step,
        stepDetail: null,
        tab: action.tab,
      });
    case ImportSidePanelAction.GetStepDetailSuccess:
      return Object.freeze({
        ...state,
        isLoading: false,
        stepDetail: action.stepDetail,
      });
    case ImportSidePanelAction.GetStepDetailFailure:
      return Object.freeze({
        ...state,
        error: action.error,
        isLoading: false,
      });
    default:
      throw new Error(`Action ${JSON.stringify(action)} not handled in importSidePanelReducer`);
  }
};
